export * from './category.service';
import { CategoryService } from './category.service';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './donation.service';
import { DonationService } from './donation.service';
export * from './family.service';
import { FamilyService } from './family.service';
export * from './list.service';
import { ListService } from './list.service';
export * from './member.service';
import { MemberService } from './member.service';
export * from './need.service';
import { NeedService } from './need.service';
export * from './note.service';
import { NoteService } from './note.service';
export * from './organisationMember.service';
import { OrganisationMemberService } from './organisationMember.service';
export * from './tokens.service';
import { TokensService } from './tokens.service';
export * from './users.service';
import { UsersService } from './users.service';
export const APIS = [CategoryService, DashboardService, DonationService, FamilyService, ListService, MemberService, NeedService, NoteService, OrganisationMemberService, TokensService, UsersService];
